import { Icon } from '@/shared/types/icon';

const BubbleSparkle = ({ size = 46 }: Icon) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#1B66D6" />
      <g
        transform="translate(9.6 9.6) scale(1.2)"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20.5714 13.684V15.7978C20.5714 16.5261 19.981 17.1165 19.2527 17.1165H10.0219L6.06589 21.0725V17.1165H4.74721C4.01892 17.1165 3.42853 16.5261 3.42853 15.7978V5.24837C3.42853 4.52008 4.01892 3.92969 4.74721 3.92969H11.0758" />
        <path
          fill="#fff"
          d="M18.4409 8.79437C19.3354 7.89947 21.7128 7.49529 21.7128 7.49529C21.7128 7.49529 19.4178 6.97771 18.5398 6.09998C17.6617 5.22204 17.1443 2.92773 17.1443 2.92773C17.1443 2.92773 16.6215 5.22113 15.7423 6.09872C14.864 6.97546 12.5714 7.49619 12.5714 7.49619C12.5714 7.49619 14.8704 8.01251 15.7495 8.89173C16.6288 9.77108 17.1443 12.0692 17.1443 12.0692C17.1443 12.0692 17.5455 9.6902 18.4409 8.79437Z"
        />
      </g>
    </svg>
  );
};

export default BubbleSparkle;
